import { ethers } from 'ethers';
import { ReactElement, createRef, useLayoutEffect, useMemo } from 'react';
import { blo } from 'blo';

declare interface AddressIconProps {
    address: string;
    size?: number;
}

const AddressIcon = ({ address, size }: AddressIconProps): ReactElement => {
    const ethIcon = createRef<HTMLImageElement>();
    const imgSize = useMemo(() => (size ? size : 32), [size]);
    useLayoutEffect(() => {
        if (!ethIcon.current || !ethers.utils.isAddress(address)) {
            return;
        }
        ethIcon.current.src = blo(address as any, 14);
    }, [ethIcon.current, address]);
    return <img ref={ethIcon} width={imgSize} height={imgSize} />;
};
export default AddressIcon;
